export default __webpack_public_path__ + "static/media/en.c58ff0de.png";